import { render, staticRenderFns } from "./ChartJs.vue?vue&type=template&id=4c94497d&"
import script from "./ChartJs.vue?vue&type=script&lang=js&"
export * from "./ChartJs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c94497d')) {
      api.createRecord('4c94497d', component.options)
    } else {
      api.reload('4c94497d', component.options)
    }
    module.hot.accept("./ChartJs.vue?vue&type=template&id=4c94497d&", function () {
      api.rerender('4c94497d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/ChartJs.vue"
export default component.exports